import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import Select from "react-select";
import EditClientAdditionalData from "./editClientAdditionalData.js";

const MySwal = withReactContent(Swal2);

const AddClient = (props) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [statuses, setStatuses] = useState([]);
  const [nTeam, setNTeam] = useState(
    props.mode === "lead" ? props.lead.finishTeam : "1"
  );
  const [lawyer, setLawyer] = useState(
    props.mode === "lead"
      ? props.lead.owner
      : props.mode === "edit"
      ? props.client.client_owner
      : ""
  );
  const [lawyerInitials, setLawyerInitials] = useState(
    props.mode === "edit" ? props.lawyerName : ""
  );
  const [court, setCourt] = useState(
    props.mode === "lead"
      ? props.lead.finishCourt
      : props.mode === "edit"
      ? props.client.court
      : ""
  );
  const [bank, setBank] = useState(
    props.mode === "lead"
      ? props.lead.bank
      : props.mode === "edit"
      ? props.client.bank
      : ""
  );
  const [type, setType] = useState(
    props.mode === "edit" ? props.client.type : ""
  );
  const [wps, setWps] = useState("");
  const [creditValue, setCreditValue] = useState(
    props.mode === "lead"
      ? props.lead.aggCreditValue
      : props.mode === "edit"
      ? props.client.credit_value.split(" ")[0]
      : ""
  );
  const [creditDate, setCreditDate] = useState(
    props.mode === "edit" ? props.client.service_aggrement_date : ""
  );
  const [creditCurrency, setCreditCurrency] = useState(
    props.mode === "lead"
      ? props.lead.creditCurrency
      : props.mode === "edit"
      ? props.client.credit_value.split(" ")[1]
      : ""
  );
  const [ow, setOw] = useState(
    props.mode === "lead"
      ? props.lead.aggValue
      : props.mode === "edit"
      ? props.client.ow
      : ""
  );
  const [sf, setSf] = useState(
    props.mode === "lead"
      ? props.lead.aggSFValue
      : props.mode === "edit"
      ? (+props.client.sf.replaceAll("%", "") * 100).toFixed(2)
      : ""
  );
  const [note, setNote] = useState(
    props.mode === "lead"
      ? props.lead.finishNote
      : props.mode === "edit"
      ? props.client.note
      : ""
  );
  const [wn, setWn] = useState(
    props.mode === "lead"
      ? props.lead.finishCaseCh.toUpperCase()
      : props.mode === "edit"
      ? props.client.application_for_protection
      : ""
  );
  const [status, setStatus] = useState(
    props.mode === "edit" ? props.client.status : ""
  );
  const [orig_agrr, setOrig_agrr] = useState(
    props.mode === "edit" ? props.client.orig_aggr : ""
  );
  const [clientsE, setClientsE] = useState(
    props.mode === "lead" ? props.lead.name.split(",") : []
  );
  const [loading, setLoading] = useState(false);
  const [phoneE, setPhoneE] = useState(
    props.mode === "lead"
      ? props.lead.phone.split(",")
      : props.mode === "edit"
      ? props.client.phone.split(",")
      : []
  );
  const [mailE, setMailE] = useState(
    props.mode === "lead"
      ? props.lead.mail.split(",")
      : props.mode === "edit"
      ? props.client.email.split(",")
      : []
  );
  const [sf_type, setSfType] = useState(
    props.mode === "edit" ? props.client.sf_type : ""
  );
  const [creaditDate_real, setCreditdate_real] = useState(
    props.mode === "lead"
      ? props.lead.aggCreditDate
      : props.mode === "edit"
      ? props.client.credit_date
      : "2008-07-01"
  );
  const [bankAcc, setBankAcc] = useState("");
  const [brand, setBrand] = useState("KPPP");
  const [firstPayDate, setFirstPayDate] = useState(
    props.mode === "lead" ? props.lead.aggFirstPayDate : ""
  );
  const [typeP, setTypeP] = useState("Opłata wstępna");
  const [bill, setBill] = useState(
    props.mode === "lead" ? props.lead.aggValue : ""
  );
  const [source, setSource] = useState("własna");
  const [installmentCount, setInstallmentCount] = useState(
    props.mode === "lead" ? props.lead.aggInstallment : ""
  );
  const [statusNote, setStatusNote] = useState(
    props.mode === "edit" ? props.client.status_note : ""
  );
  const [credit_aggr_num, setCredit_aggr_num] = useState(
    props.mode === "lead"
      ? props.lead.aggCreditNumber
      : props.mode === "edit"
      ? props.client.credit_aggr_num
      : ""
  );
  const [lawyerOptions, setLawyerOptions] = useState([]);
  const [courtOptions, setCourtOptions] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [oriOptions, setOriOptions] = useState([]);
  const [wnOptions, setWnOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [sftypeOptions, setSftypeOptions] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [showEditClientAdditionalData, setShowEditClientAdditionalData] =
    useState(false);
  const [additionalData, setAdditionalData] = useState(
    props.mode === "lead" ? props.lead.aggAdditionalData : ""
  );
  const [files, setFiles] = useState([]);
  const [users, setUsers] = useState([]);
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("add");
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [statusM, setStatusM] = useState(false);
  const [freeDays, setFreeDays] = useState([]);
  const [payed, setPayed] = useState(
    props.mode === "lead"
      ? props.lead.finishPayed === "1"
        ? true
        : false
      : props.mode === "edit"
      ? props.client.payed === "1"
        ? true
        : false
      : false
  );
  const [markAggr, setMarkAggr] = useState(
    props.mode === "lead"
      ? props.lead.markAggr === "1"
        ? true
        : false
      : props.mode === "edit"
      ? props.client.markAggr === "1"
        ? true
        : false
      : false
  );

  const [ammountA, setAmmountA] = useState(0);
  const [titleA, setTitleA] = useState("nakaz zapłaty w upominawczym");
  const [titleAOptions, setTitleAoptions] = useState([]);
  const [komorA, setKomorA] = useState("TAK");
  const [nakDateA, setNakDateA] = useState("2025-07-01");
  const [rodzPostA, setRodzPostA] = useState("EPU");
  const [conEpuA, setConEpuA] = useState("TAK");
  const [logEpuA, setLogEpuA] = useState("***");
  const [wnpwuA, setWnpwuA] = useState("TAK");
  const [teamA, setTeamA] = useState("1");

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  var clientId = "";

  const handleDeleteClient = (e) => {
    var newArray = [];
    if (props.mode === "edit" || props.mode === "lead") {
      newArray = clientsE.filter((el) => el !== e.target.value);
    } else {
      newArray = clientsE.filter((el) => el.id !== +e.target.value);
    }
    setClientsE(newArray);
  };

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data);
        fetchStatuses();
      })
      .catch((error) => {});
  };

  const fetchStatuses = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatusOptions(createStatusOptions(data));
        setStatuses(data);
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        if (props.mode === "lead") {
          fetchFiles();
        } else {
          fetchFreeDays();
        }
      })
      .catch((error) => {});
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);
    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const fetchFiles = async () => {
    var body = { leadId: props.lead.id };

    await fetch("https://apidevkppp.ftpeople.pl/getSellFilesLeadId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFiles(
          data.filter((el) => el.type === "sellFinish" || el.type === "sell")
        );
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getLawyerName = (initials) => {
    var name = users.filter((el) => el.initials === initials)[0].name;
    return name.length > 0 ? name : "prawnik";
  };

  const handleDeletePhone = (e) => {
    var newArray = [];
    if (props.mode === "edit" || props.mode === "lead") {
      newArray = phoneE.filter((el) => el !== e.target.value);
    } else {
      newArray = phoneE.filter((el) => el.id !== +e.target.value);
    }
    setPhoneE(newArray);
  };
  const handleDeleteMail = (e) => {
    var newArray = [];
    if (props.mode === "edit" || props.mode === "lead") {
      newArray = mailE.filter((el) => el !== e.target.value);
    } else {
      newArray = mailE.filter((el) => el.id !== +e.target.value);
    }
    setMailE(newArray);
  };

  const getData = () => {
    setLoading(true);
    setLawyerOptions(createLawyerOptions());
    setCourtOptions(createCourtOptions());
    setTypeOptions(createTypeOptions());
    setTitleAoptions(createTitleAOptions);
    setOriOptions(createYesNoOptions());
    setWnOptions(createYesNoTwoOptions());

    setBankOptions(createBankOptions());
    setCurrencyOptions(createCurrencyOptions());
    setSftypeOptions(createSFTypeOptions());
    fetchHolidays();
    if (props.mode === "lead") {
      setLawyerInitials(getInitials(props.lead.owner));
    }
  };

  useEffect(() => {
    if (props.mode === "lead" && props.lead.aggName) {
      setClientsE(props.lead.aggName.split(","));
    }
    if (props.mode === "edit" && props.client.petitioner) {
      setClientsE(props.client.petitioner.split(","));
    }

    getData();
  }, []);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleSourceChange = (e) => {
    setSource(e.target.value);
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const handleStatusNoteChange = (e) => {
    setStatusNote(e.target.value);
  };

  const handleOwChange = (e) => {
    setOw(e.target.value);
  };

  const handleCreditDateRealChange = (e) => {
    setCreditdate_real(e.target.value);
  };

  const handleWnChange = (e) => {
    setWn(e.value);
  };

  const handleStatusChange = (e) => {
    setStatusM(true);
    setStatus(e.value);
  };

  const handleSfChange = (e) => {
    setSf(e.target.value);
  };

  const handleSfTypeChange = (e) => {
    setSfType(e.value);
  };

  const handleCreditValueChange = (e) => {
    setCreditValue(e.target.value);
  };

  const handleCreditCurrencyChange = (e) => {
    setCreditCurrency(e.value);
  };

  const handleCreditDateChange = (e) => {
    setCreditDate(e.target.value);
  };

  const handleMailChange = (e) => {
    setMail(e.target.value);
  };

  const handleLawyerChange = (e) => {
    setLawyer(e.value);
    if (e.value === "brak danych") {
      setLawyerInitials("brak danych");
    } else {
      setLawyerInitials(getInitials(e.value));
    }
  };

  const handleCourtChange = (e) => {
    setCourt(e.value);
  };

  const handleBankChange = (e) => {
    setBank(e.value);
  };

  const handleTypeChange = (e) => {
    setType(e.value);
    setBankOptions(createBankOptions(e.value));
  };

  const handleOrigAggrChange = (e) => {
    setOrig_agrr(e.value);
  };

  const generateName = () => {
    var name = "";

    if (props.mode === "edit" || props.mode === "lead") {
      if (clientsE.length === 1) {
        name = clientsE[0];
      } else {
        for (var i = 0; i < clientsE.length; i = i + 1) {
          name = name + clientsE[i] + (i === clientsE.length - 1 ? "" : ", ");
        }
      }
    } else {
      if (clientsE.length === 1) {
        name = clientsE[0].name;
      } else {
        for (var i = 0; i < clientsE.length; i = i + 1) {
          name =
            name + clientsE[i].name + (i === clientsE.length - 1 ? "" : ", ");
        }
      }
    }

    return name;
  };

  const generatePhone = () => {
    var name = "";
    if (props.mode === "edit" || props.mode === "lead") {
      if (phoneE.length === 1) {
        name = phoneE[0];
      } else {
        for (var i = 0; i < phoneE.length; i = i + 1) {
          name = name + phoneE[i] + (i === phoneE.length - 1 ? "" : ", ");
        }
      }
    } else {
      if (phoneE.length === 1) {
        name = phoneE[0].phone;
      } else {
        for (var i = 0; i < phoneE.length; i = i + 1) {
          name = name + phoneE[i].phone + (i === phoneE.length - 1 ? "" : ", ");
        }
      }
    }
    return name;
  };

  const generateMail = () => {
    var name = "";
    if (props.mode === "edit" || props.mode === "lead") {
      if (mailE.length === 1) {
        name = mailE[0];
      } else {
        for (var i = 0; i < mailE.length; i = i + 1) {
          name = name + mailE[i] + (i === mailE.length - 1 ? "" : ", ");
        }
      }
    } else {
      if (mailE.length === 1) {
        name = mailE[0].mail;
      } else {
        for (var i = 0; i < mailE.length; i = i + 1) {
          name = name + mailE[i].mail + (i === mailE.length - 1 ? "" : ", ");
        }
      }
    }
    return name;
  };

  const checkIfIdentifierisUniqe = async (id) => {
    var rows = await props.clientsSheetData.getRows();
    var arr = rows.filter((el) => el.identifier === id);

    if (arr.length > 0) {
      return false;
    }

    return true;
  };

  const addSygn = async (id) => {
    var body = {
      clientId: id,
      sygn: "",
      date:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate()) +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds(),
      court: court,
      who: props.user.name,
      add: false,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addSygnClient", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data2) => {
        return;
      })
      .catch((error) => {});
  };

  const addDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 7));
    return retDate;
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const addDay49 = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 49));
    return retDate;
  };

  const addClientMW = async (paymentId) => {
    if (props.mode === "lead") {
      var bodya = {
        id: props.lead.id,
      };

      fetch("https://apidevkppp.ftpeople.pl/archivizeLead", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(bodya),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
    }

    var clientId = "";
    var responsible = "";

    var model = [];

    users
      .filter((el) => (+props.team === 0 ? true : el.team.includes(props.team)))
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Wybierz pracownika - mamy wezwanie",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        responsible = result.value;

        var body = {
          petitioner: generateName(),
          client_owner:
            lawyer === "brak danych" ? "brak danych" : getInitials(lawyer),
          type: type,
          phone: generatePhone(),
          email: generateMail(),
          status: status,
          court: court,
          bank: bank,
          credit_value: creditValue + " " + creditCurrency,
          service_agreement_date: creditDate,
          ow: ow,
          sf: sf / 100,
          application_for_protection: wn,
          note: note.length > 0 ? note : "",
          accepted: "no",
          orig_aggr: orig_agrr,
          sf_type: sf_type,
          special_client: "NIE",
          credit_date: creaditDate_real,
          quest_pass: paymentId,
          status_note: statusNote,
          credit_aggr_num: credit_aggr_num.replaceAll("\\", "_"),
          team: +props.team === 0 ? nTeam : props.team,
          source: source,
          additionalData: additionalData,
          leadId: props.mode === "lead" ? props.lead.id : "",
          payed: payed ? "1" : "0",
          markAggr: markAggr ? "1" : "0",
          ammountA: type === "antywindykacja" ? ammountA : "",
          titleA: type === "antywindykacja" ? titleA : "",
          komorA: type === "antywindykacja" ? komorA : "",
          nakDateA: type === "antywindykacja" ? nakDateA : "",
          rodzPostA: type === "antywindykacja" ? rodzPostA : "",
          conEpuA: type === "antywindykacja" ? conEpuA : "",
          logEpuA: type === "antywindykacja" ? logEpuA : "",
          wnpwuA: type === "antywindykacja" ? wnpwuA : "",
        };

        await fetch("https://apidevkppp.ftpeople.pl/addClient", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then(async (data) => {
            clientId = data;
            addSygn(data);

            await sendFiles(data);

            if (props.mode === "lead") {
              var body2 = {
                leadId: props.lead.id,
                clientId: data,
              };

              await fetch("https://apidevkppp.ftpeople.pl/addClientSellFiles", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body2),
              })
                .then((response) => response.text())
                .then(async (data5) => {})
                .catch((error) => {});
            }

            var body2 = {
              identifier: paymentId,
              clientId: clientId,
              mail: generateMail(),
              phone: generatePhone(),
            };

            await fetch("https://apidevkppp.ftpeople.pl/addClientPayment", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.text())
              .then(async (data3) => {
                var date_added2 =
                  new Date().getFullYear() +
                  "-" +
                  (new Date().getMonth() + 1) +
                  "-" +
                  new Date().getDate() +
                  " " +
                  new Date().getHours() +
                  ":" +
                  new Date().getMinutes();
                var date_add = addDay(new Date());

                while (
                  (checkFree(date_add) ||
                    checkHoliday(result.value, date_add)) &&
                  (date_add.getDay() === 0 || date_add.getDay() === 6)
                ) {
                  date_add = addDayOne(date_add);
                }

                var date_start2 =
                  date_add.getFullYear() +
                  "-" +
                  (date_add.getMonth() + 1) +
                  "-" +
                  date_add.getDate();

                var date_start_new =
                  new Date().getFullYear() +
                  "-" +
                  (new Date().getMonth() + 1) +
                  "-" +
                  new Date().getDate();

                var body3 = {
                  responsible: result.value,
                  start_date: date_start_new,
                  final_date: date_start2,
                  bank: bank,
                  sygn: "",
                  client_name: generateName(),
                  task:
                    type === "sankcja kredytu darmowego"
                      ? "Wezwanie do zapłaty z oświadczeniem"
                      : "Wezwanie do zapłaty",
                  date_added: date_added2,
                  user_added: lawyer,
                  status: "ZLECONE",
                  court: court,
                  type: "SĄDOWE",
                  reded: "no",
                  clientId: data,
                  task_conn: "c",
                  team: +props.team === 0 ? nTeam : props.team,
                };

                await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body3),
                })
                  .then((response) => response.text())
                  .then(async (data4) => {
                    var body4 = {
                      id: clientId,
                      data_zasw:
                        new Date().getFullYear() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getDate(),
                      resp: result.value,
                    };

                    await fetch("https://apidevkppp.ftpeople.pl/addDZClient", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: secretKey,
                      },
                      body: JSON.stringify(body4),
                    })
                      .then((response) => response.text())
                      .then(async (data5) => {
                        var newFinalDate3 = addDay49(new Date());

                        if (newFinalDate3.getDay() === 0) {
                          newFinalDate3 = new Date(
                            newFinalDate3.setDate(newFinalDate3.getDate() + 1)
                          );
                        }
                        if (newFinalDate3.getDay() === 6) {
                          newFinalDate3 = new Date(
                            newFinalDate3.setDate(newFinalDate3.getDate() + 2)
                          );
                        }

                        while (
                          checkHoliday(responsible, newFinalDate3) &&
                          (date_add.getDay() === 0 || date_add.getDay() === 6)
                        ) {
                          newFinalDate3 = addDayOne(newFinalDate3);
                        }

                        var dateFinal3 =
                          newFinalDate3.getFullYear() +
                          "-" +
                          (newFinalDate3.getMonth() + 1) +
                          "-" +
                          newFinalDate3.getDate();

                        var body2 = {
                          start_date: date_start_new,
                          final_date: dateFinal3,
                          bank: bank,
                          sygn: "",
                          responsible: lawyer,
                          client_name: generateName(),
                          task: "Za 7 dni upływa terminu do wysłania pozwu",
                          date_added: date_added2,
                          user_added: "",
                          status: "ZLECONE",
                          court: court,
                          type: "POZASĄDOWE",
                          readed: "no",
                          clientId: clientId,
                          task_conn: "c",
                          team: +props.team === 0 ? nTeam : props.team,
                        };

                        await fetch(
                          "https://apidevkppp.ftpeople.pl/insertTask",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                            body: JSON.stringify(body2),
                          }
                        )
                          .then((response) => response.text())
                          .then(async (data6) => {
                            var body3 = {
                              id: clientId,
                              praw_wezw: result.value,
                            };

                            await fetch(
                              "https://apidevkppp.ftpeople.pl/addPWClient",
                              {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: secretKey,
                                },
                                body: JSON.stringify(body3),
                              }
                            )
                              .then((response) => response.text())
                              .then((data7) => {})
                              .catch((error) => {});
                          });
                      })
                      .catch((error) => {});
                  })
                  .catch((error) => {});
              })
              .catch((error) => {});

            props.logClientAction("Dodano sprawę", data);

            if (source === "własna") {
              MySwal.fire({
                title:
                  "Czy chcesz wysłać klientowi indywidualny kod do płatności + link do ankiety?",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Tak",
                denyButtonText: `Nie`,
              }).then((result) => {
                if (result.isConfirmed) {
                  emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
                  var templateParams = {
                    clientId: data,
                    paymentId: paymentId,
                    link:
                      "https://workflow.kppp.pl/?clientQuest=1&client=" + data,
                    to: mailE[0].mail,
                    reply_to: props.userMail,
                  };

                  var content = `Dzień dobry, dziękujemy za przesłane dokumenty. Przy płatności rat na rzecz kancelarii proszę wskazywać w tytule przelewu indywidualny identyfikator płatności: ${paymentId}, co pozwoli programowi księgowemu na prawidłowe rozliczenie płatności. Numer rachunku bankowego: 85 1050 1575 1000 0097 4417 6380, Kancelaria Radcy Prawnego Mateusz Płudowski, ul. Gwiaździsta 10/10/1, 53-413 Wrocław. Proszę również o uzupełnienie informacji niezbędnych do sporządzenia pozwu – informacje proszę uzupełnić pod adresem (link poniżej): ${link}. Hasło do ankiety to: ${paymentId}.`;
                  if (type === "antywindykacja") {
                    content = `Dzień dobry,
                    dziękujemy za przesłane dokumenty.
                    Przy płatności rat na rzecz kancelarii proszę wskazywać w tytule przelewu indywidualny identyfikator płatności: ${paymentId}, co pozwoli programowi księgowemu na prawidłowe rozliczenie płatności.
                    ‌
                    Numer rachunku bankowego: 15 1050 1575 1000 0092 5701 7450
                    Kancelaria Radcy Prawnego Mateusz Płudowski
                    ul. Gwiaździsta 10/10/1
                    53-413 Wrocław`;
                  }
                  var body = {
                    type: "wprowadzenie klienta",
                    content: content.replaceAll("'", ""),
                    date: new Date(),
                    clientId: data,
                    user: props.user.name,
                  };

                  fetch("https://apidevkppp.ftpeople.pl/addClientContact", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body),
                  })
                    .then((response) => response.json())
                    .then((data) => {})
                    .catch((error) => {});

                  emailjs
                    .send(
                      "KPPP",
                      type === "antywindykacja"
                        ? "template_tb5zmc3"
                        : "template_0hqtmlw",
                      templateParams
                    )
                    .then(
                      function (response) {
                        MySwal.fire({
                          icon: "success",
                          title: "Dodano",
                          text: "nową sprawę",
                        }).then(async (result) => {
                          props.close();
                        });
                      },
                      function (error) {
                        MySwal.fire({
                          icon: "error",
                          title: "Błąd",
                          text: "nie wysłano wiadomości e-mail. Ponów operację!",
                        }).then(async (result) => {
                          props.close();
                        });
                      }
                    );
                } else if (result.isDenied) {
                  MySwal.fire({
                    icon: "success",
                    title: "Dodano",
                    text: "nową sprawę",
                  }).then(async (result) => {
                    props.close();
                  });
                }
              });
            } else {
              MySwal.fire({
                icon: "success",
                title: "Dodano",
                text: "nową sprawę",
              }).then(async (result) => {
                props.close();
              });
            }
          })
          .catch((error) => {});
      }
    });
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= final_date && el.date_from <= final_date) ||
          (final_date >= el.date_from && final_date <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const addClient = async (paymentId) => {
    var body = {
      petitioner: generateName(),
      client_owner:
        lawyer === "brak danych" ? "brak danych" : getInitials(lawyer),
      type: type,
      phone: generatePhone(),
      email: generateMail(),
      status: status,
      court: court,
      bank: bank,
      credit_value: creditValue + " " + creditCurrency,
      service_agreement_date: creditDate,
      ow: ow,
      sf: sf / 100,
      application_for_protection: wn,
      note: note.length > 0 ? note : "",
      accepted: "no",
      orig_aggr: orig_agrr,
      sf_type: sf_type,
      special_client: "NIE",
      credit_date: creaditDate_real,
      quest_pass: paymentId,
      status_note: statusNote,
      credit_aggr_num: credit_aggr_num,
      team:
        type === "antywindykacja"
          ? teamA
          : +props.team === 0
          ? nTeam
          : props.team,
      source: source,
      additionalData: additionalData,
      leadId: props.mode === "lead" ? props.lead.id : "",
      payed: payed ? "1" : "0",
      markAggr: markAggr ? "1" : "0",
      ammountA: type === "antywindykacja" ? ammountA : "",
      titleA: type === "antywindykacja" ? titleA : "",
      komorA: type === "antywindykacja" ? komorA : "",
      nakDateA: type === "antywindykacja" ? nakDateA : "",
      rodzPostA: type === "antywindykacja" ? rodzPostA : "",
      conEpuA: type === "antywindykacja" ? conEpuA : "",
      logEpuA: type === "antywindykacja" ? logEpuA : "",
      wnpwuA: type === "antywindykacja" ? wnpwuA : "",
    };

    await fetch("https://apidevkppp.ftpeople.pl/addClient", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        addSygn(data);

        await sendFiles(data);

        if (props.mode === "lead") {
          var body5 = {
            leadId: props.lead.id,
            clientId: data,
          };

          await fetch("https://apidevkppp.ftpeople.pl/addClientSellFiles", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body5),
          })
            .then((response) => response.text())
            .then(async (data5) => {})
            .catch((error) => {});
        }

        var body2 = {
          identifier: paymentId,
          clientId: data,
          mail: generateMail(),
          phone: generatePhone(),
        };

        await fetch("https://apidevkppp.ftpeople.pl/addClientPayment", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.text())
          .then((data3) => {});

        props.logClientAction("Dodano sprawę", data);

        if (source === "własna") {
          MySwal.fire({
            title:
              "Czy chcesz wysłać klientowi indywidualny kod do płatności + link do ankiety?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then((result) => {
            if (result.isConfirmed) {
              emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
              var templateParams = {
                clientId: data,
                paymentId: paymentId,
                link: "https://workflow.kppp.pl/?clientQuest=1&client=" + data,
                to: props.mode === "lead" ? mailE[0] : mailE[0].mail,
                reply_to: props.userMail,
                asdasd: props.userMail,
              };

              var link =
                "https://workflow.kppp.pl/?clientQuest=1&client=" + data;
              var content = `Dzień dobry, dziękujemy za przesłane dokumenty. Przy płatności rat na rzecz kancelarii proszę wskazywać w tytule przelewu indywidualny identyfikator płatności: ${paymentId}, co pozwoli programowi księgowemu na prawidłowe rozliczenie płatności. Numer rachunku bankowego: 85 1050 1575 1000 0097 4417 6380, Kancelaria Radcy Prawnego Mateusz Płudowski, ul. Gwiaździsta 10/10/1, 53-413 Wrocław. Proszę również o uzupełnienie informacji niezbędnych do sporządzenia pozwu – informacje proszę uzupełnić pod adresem (link poniżej): ${link}. Hasło do ankiety to: ${paymentId}.`;
              if (type === "antywindykacja") {
                content = `Dzień dobry,
                dziękujemy za przesłane dokumenty.
                Przy płatności rat na rzecz kancelarii proszę wskazywać w tytule przelewu indywidualny identyfikator płatności: ${paymentId}, co pozwoli programowi księgowemu na prawidłowe rozliczenie płatności.
                ‌
                Numer rachunku bankowego: 15 1050 1575 1000 0092 5701 7450
                Kancelaria Radcy Prawnego Mateusz Płudowski
                ul. Gwiaździsta 10/10/1
                53-413 Wrocław`;
              }

              var body = {
                type: "wprowadzenie klienta",
                content: content.replaceAll("'", ""),
                date: new Date(),
                clientId: data,
                user: props.user.name,
              };

              fetch("https://apidevkppp.ftpeople.pl/addClientContact", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});

              emailjs
                .send(
                  "KPPP",
                  type === "antywindykacja"
                    ? "template_tb5zmc3"
                    : "template_0hqtmlw",
                  templateParams
                )
                .then(
                  function (response) {
                    MySwal.fire({
                      icon: "success",
                      title: "Dodano",
                      text: "nową sprawę",
                    }).then(async (result) => {
                      props.close();
                    });
                  },
                  function (error) {
                    MySwal.fire({
                      icon: "error",
                      title: "Błąd",
                      text: "nie wysłano wiadomości e-mail. Ponów operację!",
                    }).then(async (result) => {
                      props.close();
                    });
                  }
                );
            } else if (result.isDenied) {
              MySwal.fire({
                icon: "success",
                title: "Dodano",
                text: "nową sprawę",
              }).then(async (result) => {
                props.close();
              });
            }
          });
        } else {
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "nową sprawę",
          }).then(async (result) => {
            props.close();
          });
        }
      })
      .catch((error) => {});
  };

  const getInitials = (lawyer) => {
    if (users.length === 0) {
      return;
    }
    if (lawyer.length > 4) {
      return users.filter((el) => el.name === lawyer)[0].initials;
    } else {
      return lawyer;
    }
  };

  const validateClientEdit = () => {
    if (props.checkEditOption("phone")) {
      if (generatePhone().length > 0) {
        return true;
      }
    }

    if (props.checkEditOption("name")) {
      if (generateName().length > 0) {
        return true;
      }
    }

    if (props.checkEditOption("mail")) {
      if (generateMail().length > 0) {
        return true;
      }
    }
  };

  const archivizePayment = async (id) => {
    var toEditData = props.payments.filter((el) => el.identifier === id)[0];
    var body = {
      name: toEditData.name,
      identifier: toEditData.identifier,
      email: toEditData.email,
      phone: toEditData.phone,
      first_payment_date: toEditData.first_payment_date,
      company: toEditData.company,
      type: toEditData.type,
      to_settlement: toEditData.to_settlement,
      installment: toEditData.installment,
      pay_sum: toEditData.pay_sum,
      pay_count: toEditData.pay_count,
      pay_expected_count: toEditData.pay_expected_count,
      last_pay_date: toEditData.last_pay_date,
      is_overdated: toEditData.is_overdated,
      to_archive: toEditData.to_archive,
      archive_date: new Date(),
      clientId: toEditData.clientId,
      bank_acc: toEditData.bank_acc,
      delay_time: toEditData.delay_time,
      id: toEditData.identifier,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertPaymentArchive", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    //deletePayment(toEditData.id);
  };

  const deletePayment = async (id) => {
    var body = {
      id: id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deletePayment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const addDay3Months = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 30));
    return retDate;
  };

  const editC = async () => {
    setLoading(true);

    if (status === "zakończona - rozliczona") {
      props.payments.map((el) => {
        archivizePayment(el.identifier);
      });
    }

    var body = {
      id: props.client.id,
      petitioner: generateName(),
      phone: generatePhone(),
      email: generateMail(),
      type: type,
      client_owner:
        lawyer === "brak danych" ? "brak danych" : getInitials(lawyer),
      status: status,
      court: court,
      bank: bank,
      credit_value: creditValue + " " + creditCurrency,
      service_agreement_date: creditDate,
      ow: ow,
      sf: sf / 100,
      application_for_protection: wn,
      note: note,
      orig_aggr: orig_agrr,
      sf_type: sf_type,
      credit_date: creaditDate_real,
      status_note: statusNote,
      credit_aggr_num: credit_aggr_num.replaceAll("\\", "\\\\"),
      quest_pass: props.client.quest_pass,
      payed: payed ? "1" : "0",
      markAggr: markAggr ? "1" : "0",
    };

    await fetch("https://apidevkppp.ftpeople.pl/editClient", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        return;
      })
      .catch((error) => {});

    if (statusM) {
      props.logClientAction(
        "Zmieniono status sprawy klienta: ",
        props.client.id
      );
      if (status === "zakończona - nierozliczona") {
        var model = [];

        props.users
          .filter((el) => el.team.includes(props.client.team))
          .map((element) => {
            model[element.name] = element.name;
          });

        MySwal.fire({
          title: "Kto rozlicza sprawę?",
          input: "select",
          inputOptions: model,
          inputPlaceholder: "wybierz pracownika",
          showCancelButton: true,
          cancelButtonText: "Anuluj",
          inputValidator: function (value) {
            return new Promise(function (resolve, reject) {
              if (value !== "") {
                resolve();
              } else {
                resolve("musisz wybrać pracownika");
              }
            });
          },
        }).then(async function (result) {
          if (result.isConfirmed) {
            var responsible = result.value;
            var body = {
              clientId: props.client.id,
              field: "rozCase",
              value: responsible,
            };

            await fetch("https://apidevkppp.ftpeople.pl/updateClientTable", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.text())
              .then(async (data) => {
                try {
                  var date_added =
                    new Date().getFullYear() +
                    "-" +
                    (new Date().getMonth() + 1) +
                    "-" +
                    new Date().getDate() +
                    " " +
                    new Date().getHours() +
                    ":" +
                    new Date().getMinutes();
                  var date_start =
                    new Date().getFullYear() +
                    "-" +
                    (new Date().getMonth() + 1) +
                    "-" +
                    new Date().getDate();
                  var dateFinal = new Date();

                  var newFinalDate = addDay3Months(new Date());
                  if (newFinalDate.getDay() === 0) {
                    newFinalDate = new Date(
                      newFinalDate.setDate(newFinalDate.getDate() + 1)
                    );
                  }
                  if (newFinalDate.getDay() === 6) {
                    newFinalDate = new Date(
                      newFinalDate.setDate(newFinalDate.getDate() + 2)
                    );
                  }

                  var date_final = newFinalDate;

                  while (
                    (checkFree(date_final) ||
                      checkHoliday(responsible, date_final)) &&
                    (date_final.getDay() === 0 || date_final.getDay() === 6)
                  ) {
                    date_final = addDayOne(date_final);
                  }

                  dateFinal =
                    date_final.getFullYear() +
                    "-" +
                    (date_final.getMonth() + 1) +
                    "-" +
                    date_final.getDate();

                  var body5 = {
                    responsible: responsible,
                    start_date: date_start,
                    final_date: dateFinal,
                    bank: props.client.bank,
                    sygn: props.client.aCourt,
                    client_name: props.client.petitioner,
                    task: "Czy wykonałeś wszystkie czynności związane z rozliczeniem sprawy np. podpisanie porozumienia kompensacyjnego, wysłanie wezwania i oświadczenia o potrąceniu, dodanie płatności do modułu, wysłanie rozliczenia KZP do pełnomocnika banku i rozliczenia SCF do klienta?",
                    date_added: date_added,
                    user_added: props.userD.name,
                    status: "ZLECONE",
                    court: props.client.aCourt,
                    type: "POZASĄDOWE",
                    readed: "no",
                    addRole: props.userD.role,
                    cycleId: "",
                    clientId: props.client.id,
                    task_conn: "c",
                    team: props.client.team,
                    note: "",
                  };

                  await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body5),
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      MySwal.fire({
                        icon: "success",
                        title: "Edytowano",
                        text: "sprawę",
                      }).then(async (result) => {
                        props.close();
                      });
                    })
                    .catch((error) => {});
                } catch (err) {}
              })
              .catch((error) => {});
          }
        });
      } else {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "sprawę",
        }).then(async (result) => {
          props.close();
        });
      }
    } else {
      props.logClientAction("Edytowano sprawę", props.client.id);
      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    }
  };

  const editClient = async (e) => {
    if (generatePhone().length > 0 && generateMail().length > 0) {
      editC();
    } else {
      MySwal.fire({
        title:
          "Na karcie klienta nie zostały uzupełnione poprawnie wszyskti pola, czy chcesz zapisać zmianę?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          editC();
        } else {
          MySwal.fire({
            icon: "error",
            title: "Błąd",
            text: "Wypełnij wymagane pola formularza",
          });
        }
      });
    }
  };

  const sendFiles = async (clientId) => {
    var length = uploadFilesArray.length;
    var progr = 0;
    uploadFilesArray.map(async (file) => {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", fileType);
      formData.append("clientId", clientId);
      formData.append("taskId", "");
      formData.append("user", props.user.name);

      await fetch("https://apidevkppp.ftpeople.pl/uploadFile", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.text();
        })
        .then((responseJson) => {
          ++progr;
          MySwal.fire({
            icon: "success",
            title: "Wysłano plik: " + progr + "/" + length,
            text: "",
          });
        });
    });
  };

  const validatePayment = (e) => {
    if (
      (type === "antywindykacja" ? true : creaditDate_real.length > 0) &&
      (type === "antywindykacja" ? true : credit_aggr_num.length > 0) &&
      note.length > 0 &&
      orig_agrr.length > 0 &&
      clientsE.length > 0 &&
      phoneE.length > 0 &&
      mailE.length > 0 &&
      type.length > 0 &&
      lawyer.length > 0 &&
      bank.length > 0 &&
      court.length > 0 &&
      creditValue.toString().length > 0 &&
      creditCurrency.length > 0 &&
      (type === "antywindykacja" ? true : wn.length > 0) &&
      status.length > 0 &&
      additionalData.length > 0
    ) {
      if (source === "własna" && type !== "antywindykacja") {
        if (
          creditDate.length > 0 &&
          ow.length > 0 &&
          sf.length > 0 &&
          sf_type.length > 0 &&
          firstPayDate.length > 0 &&
          installmentCount.length > 0 &&
          brand.length > 0 &&
          typeP.length > 0
        ) {
          return true;
        } else {
          MySwal.fire({
            title:
              "Na karcie klienta nie zostały uzupełnione poprawnie wszyskti pola, czy chcesz zapisać zmianę?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              return true;
            } else {
              return false;
            }
          });
        }
      } else {
        if (type === "antywindykacja") {
          if (teamA.length > 0) {
            return true;
          } else {
            MySwal.fire({
              title:
                "Na karcie klienta nie zostały uzupełnione poprawnie wszyskti pola, czy chcesz zapisać zmianę?",
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: "Tak",
              denyButtonText: `Nie`,
            }).then(async (result) => {
              if (result.isConfirmed) {
                return true;
              } else {
                return false;
              }
            });
          }
        } else {
          return true;
        }
      }
    } else {
      MySwal.fire({
        title:
          "Na karcie klienta nie zostały uzupełnione poprawnie wszyskti pola, czy chcesz zapisać zmianę?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          return true;
        } else {
          return false;
        }
      });
    }
  };

  const handleAddClient = (e) => {
    var check = e.target.value.split(" ").length > 1;
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        if (props.mode === "edit" || props.mode === "lead") {
          clientsE.push(e.target.value);
        } else {
          clientsE.push({ id: Math.random() * 100, name: e.target.value });
        }
        setName("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Imię i nazwisko niepoprawne",
      });
    }
  };

  const handleAddPhone = (e) => {
    var check = e.target.value.length >= 9;
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        if (props.mode === "edit" || props.mode === "lead") {
          phoneE.push(e.target.value);
        } else {
          phoneE.push({ id: Math.random() * 100, phone: e.target.value });
        }
        setPhone("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Zły format numeru telefonu",
      });
    }
  };

  const handleAddMail = (e) => {
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var check = e.target.value.length > 0 && e.target.value.match(validRegex);
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        if (props.mode === "edit" || props.mode === "lead") {
          mailE.push(e.target.value);
        } else {
          mailE.push({ id: Math.random() * 100, mail: e.target.value });
        }
        setMail("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Adres e-mail niepoprawny",
      });
    }
  };

  const createStatusOptions = (data) => {
    var statusOptions = [];
    data.map((el) => {
      statusOptions.push({ label: el.name, value: el.name });
    });

    return statusOptions;
  };

  const createBankOptions = (typeX) => {
    var bankOptions = [];
    if (typeX !== "antywindykacja") {
      props.banksData
        .filter((el) => el.team.includes("1"))
        .map((el) => {
          bankOptions.push({ label: el.name, value: el.name });
        });
    } else {
      props.banksData.map((el) => {
        bankOptions.push({ label: el.name, value: el.name });
      });
    }

    return bankOptions;
  };

  const createCourtOptions = (e) => {
    var bankOptions = [];
    bankOptions.push({
      name: "Do decyzji prawnika",
      value: "Do decyzji prawnika",
    });
    props.courtsData.map((el) => {
      bankOptions.push({ label: el.name, value: el.name });
    });

    return bankOptions;
  };

  const createLawyerOptions = (e) => {
    var bankOptions = [];
    bankOptions.push({ label: "brak danych", value: "brak danych" });
    if (props.mode === "edit") {
      if (+props.client.team === 0) {
        props.lawyersData.map((el) => {
          bankOptions.push({ label: el.name, value: el.name });
        });
      } else {
        props.lawyersData
          .filter((el) => +el.team.includes(+props.client.team))
          .map((el) => {
            bankOptions.push({ label: el.name, value: el.name });
          });
      }
    } else {
      if (+props.team === 0) {
        props.lawyersData.map((el) => {
          bankOptions.push({ label: el.name, value: el.name });
        });
      } else {
        props.lawyersData
          .filter((el) => +el.team.includes(+props.team))
          .map((el) => {
            bankOptions.push({ label: el.name, value: el.name });
          });
      }
    }

    return bankOptions;
  };

  const createTitleAOptions = () => {
    var statusOptions = [];
    statusOptions.push({
      label: "brak danych",
      value: "brak danych",
    });
    statusOptions.push({
      label: "nakaz zapłaty w upominawczym",
      value: "nakaz zapłaty w upominawczym",
    });
    statusOptions.push({
      label: "nakaz zapłaty w nakazowym",
      value: "nakaz zapłaty w nakazowym",
    });
    statusOptions.push({
      label: "wyrok zaoczny",
      value: "wyrok zaoczny",
    });
    statusOptions.push({
      label: "wyrok",
      value: "wyrok",
    });

    return statusOptions;
  };

  const createTypeOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({
      label: "pozew przeciwko bankowi",
      value: "pozew przeciwko bankowi",
    });
    statusOptions.push({
      label: "pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału",
      value: "pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału",
    });
    statusOptions.push({
      label: "pozew banku o opłatę za korzystanie z kapitału",
      value: "pozew banku o opłatę za korzystanie z kapitału",
    });
    statusOptions.push({
      label: "pozew banku z tytułu wypowiedzenia umowy",
      value: "pozew banku z tytułu wypowiedzenia umowy",
    });
    statusOptions.push({
      label: "pozew banku o waloryzację",
      value: "pozew banku o waloryzację",
    });
    statusOptions.push({
      label: "pozew banku o zwrot kapitału",
      value: "pozew banku o zwrot kapitału",
    });
    statusOptions.push({
      label: "sankcja kredytu darmowego",
      value: "sankcja kredytu darmowego",
    });
    statusOptions.push({
      label: "pozew banku o zwrot kapitału i jego waloryzację",
      value: "pozew banku o zwrot kapitału i jego waloryzację",
    });
    statusOptions.push({
      label: "EURO - pozew przeciwko bankowi",
      value: "EURO - pozew przeciwko bankowi",
    });
    statusOptions.push({
      label: "WIBOR - pozew przeciwko bankowi",
      value: "WIBOR - pozew przeciwko bankowi",
    });
    statusOptions.push({
      label: "antywindykacja",
      value: "antywindykacja",
    });

    return statusOptions;
  };

  const createYesNoOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ label: "TAK", value: "TAK" });
    statusOptions.push({ label: "NIE", value: "NIE" });

    return statusOptions;
  };

  const createYesNoTwoOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ label: "TAK", value: "TAK" });
    statusOptions.push({ label: "NIE", value: "NIE" });
    statusOptions.push({
      label: "Do decyzji prawnika",
      value: "Do decyzji prawnika",
    });

    return statusOptions;
  };

  const createCurrencyOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ label: "PLN", value: "PLN" });
    statusOptions.push({ label: "CHF", value: "CHF" });
    statusOptions.push({ label: "EUR", value: "EUR" });
    statusOptions.push({ label: "USD", value: "USD" });

    return statusOptions;
  };

  const createSFTypeOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ label: "kwota korzyści", value: "benefit" });
    statusOptions.push({ label: "kwota kredytu", value: "credit" });

    return statusOptions;
  };

  const handleBankAccChange = (e) => {
    setBankAcc(e.target.value);
  };

  const handleBrandChange = (e) => {
    setBrand(e.target.value);
  };

  const handleFirstPayDateChange = (e) => {
    setFirstPayDate(e.target.value);
  };

  const handleTypePChange = (e) => {
    setTypeP(e.target.value);
  };

  const handleBillChange = (e) => {
    setBill(e.target.value);
  };

  const handleCreditAggrNumChange = (e) => {
    setCredit_aggr_num(e.target.value);
  };

  const handleInstallmentCountChange = (e) => {
    setInstallmentCount(e.target.value);
  };

  const addPayment = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      if (source === "własna") {
        var body = {
          name: generateName(),
          phone: generatePhone(),
          email: generateMail(),
          first_payment_date: firstPayDate,
          company: brand,
          type: typeP,
          to_settlement: ow,
          installment: installmentCount,
          clientId: clientId,
        };

        await fetch("https://apidevkppp.ftpeople.pl/addPayment", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then(async (data) => {
            var body = {};
            await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((dataP) => {
                var id = dataP
                  .filter((el2) => !el2.archive_date)
                  .filter((el) => +el.id === +data)[0].identifier;
                if (status === "mamy dokumenty - wezwanie do wysłania") {
                  addClientMW(id);
                } else {
                  addClient(id);
                }
              })
              .catch((error) => {});
          })
          .catch((error) => {});
      } else {
        if (status === "mamy dokumenty - wezwanie do wysłania") {
          addClientMW("");
        } else {
          addClient("");
        }
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const generateNewIdentifierP = (rows) => {
    var prefix = "";
    if (typeP === "Opłata wstępna") {
      prefix = "OW";
    } else if (typeP === "Success Fee") {
      prefix = "SF";
    } else if (typeP === "Opłata za rozprawę") {
      prefix = "OR";
    } else if (typeP === "KZP I Instancja") {
      prefix = "KZP1";
    } else if (typeP === "KZP II Instancja") {
      prefix = "KZP2";
    } else if (typeP === "KZP SN") {
      prefix = "KZP3";
    } else if (typeP === "Wynagrodzenie za skargę kasacyjną") {
      prefix = "SK";
    } else if (typeP === "KZP I i II instancja łącznie") {
      prefix = "KZP4";
    }

    var brand_short = "";

    if (brand === "KPPP") {
      brand_short = "KPP";
    }
    if (brand === "Wygrywamy z bankami") {
      brand_short = "WZB";
    }
    if (brand === "Anulujemy Kredyt CHF") {
      brand_short = "AKC";
    }
    if (brand === "Frankowa Kanclearia") {
      brand_short = "FKK";
    }

    var lastID = 0;

    var arr = [];
    arr = rows.filter((el) => el.company === brand && el.type === typeP);

    var arrNum = [];
    arr.map((el) => {
      var id = el.identifier
        .toString()
        .replaceAll(brand_short, "")
        .replaceAll(prefix, "");
      arrNum.push(+id);
    });

    var arrSrt = arrNum.sort((a, b) => {
      return a < b ? 1 : -1;
    });

    lastID = arrSrt[0];

    return prefix + brand_short + (lastID + 1);
  };

  const closeEditAdditionalData = (e) => {
    setShowEditClientAdditionalData(false);
  };

  const deleteFile = async (e) => {
    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteSellFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "plik",
    }).then((result) => {
      props.logLeadAction("Usunięto plik", props.leadData.id);
      getData();
    });
  };

  const changeFileNameK = async (e) => {
    MySwal.fire({
      title: "Wprowadź nazwę pliku",
      input: "text",
      inputPlaceholder: "Nazwa pliku",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wprowadzić nazwę pliku");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body4 = {
          id: e.target.value,
          name: result.value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/setSellFileName", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body4),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const download = async (url, filename) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("download", filename);
    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const downloadFile = (e) => {
    var file = files.filter((el) => el.id === +e.target.value)[0];
    download(file.link, file.name);
  };

  const documentsView = (
    <>
      {files.length > 0 ? (
        <>
          {files.filter((el) => el.type === "sellFinish" || el.type === "sell")
            .length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "1vw" }}>
                Pliki wgrane do zlecenia ZAŁOŻENIA SPRAWY
              </p>
              <table
                style={{ width: "92%", fontSize: "0.6vw" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th>Nazwa pliku</th>
                  <th>Użytkownik</th>
                  <th>Data</th>
                  <th>Pokaż</th>
                  <th></th>
                </tr>
                {files
                  .filter(
                    (el) => el.type === "sellFinish" || el.type === "sell"
                  )
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.name}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.user}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {new Date(file.date).getFullYear() +
                            "-" +
                            (new Date(file.date).getMonth() + 1 < 10
                              ? "0" + (new Date(file.date).getMonth() + 1)
                              : new Date(file.date).getMonth() + 1) +
                            "-" +
                            (new Date(file.date).getDate() < 10
                              ? "0" + new Date(file.date).getDate()
                              : new Date(file.date).getDate())}{" "}
                          {(new Date(file.date).getHours() < 10
                            ? "0" + new Date(file.date).getHours()
                            : new Date(file.date).getHours()) +
                            ":" +
                            (new Date(file.date).getMinutes() < 10
                              ? "0" + new Date(file.date).getMinutes()
                              : new Date(file.date).getMinutes())}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <a
                                style={{ textDecoration: "none" }}
                                className="refreshButton"
                                value={file.id}
                                href={file.link}
                                target="_blank"
                              >
                                pokaż
                              </a>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {props.view !== "client" ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFile}
                              >
                                usuń
                              </button>
                              <button
                                style={{ marginLeft: "10px" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </>
  );

  const addFile = (
    <>
      <>
        <input multiple={true} type="file" onChange={changeFiles} />
        {props.place === "main" ? (
          <>
            <div
              style={{ marginTop: "0", marginBottom: "5vh" }}
              className="inputBox"
            >
              <div className="inputCol_2">
                <label>Kategoria plików</label>
                <select
                  style={{ height: "3vh" }}
                  type="text"
                  id="court"
                  name="court"
                  value={fileType}
                  onChange={(e) => setFileType(e.target.value)}
                >
                  <option key={0} value="co-op">
                    Dokumenty do współpracy z kancelarią
                  </option>
                  <option key={1} value="credit">
                    Dokumenty kredytowe
                  </option>
                  <option key={2} value="court">
                    Pisma z sądu
                  </option>
                  <option key={2} value="bank">
                    Pisma z banku
                  </option>
                  <option key={3} value="send">
                    Pisma wysłane do sprawy
                  </option>
                  <option key={4} value="other">
                    Inne
                  </option>
                  <option key={5} value="segr">
                    Zeskanowany segregator fizyczny
                  </option>
                </select>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <>
          {uploadFilesArray.length > 0 ? (
            <>
              <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                <table
                  style={{ width: "70%", boxSizing: "border-box" }}
                  id="detailClientTable"
                  className="clients_table"
                >
                  <tr>
                    <th>Nazwa pliku</th>
                    <th>Plik</th>
                    <th></th>
                  </tr>
                  {uploadFilesArray.length > 0
                    ? uploadFilesArray.map((el, index) => (
                        <>
                          <tr>
                            <td
                              style={{
                                width: "50%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <div style={{ display: "flex", gap: "10px" }}>
                                <input
                                  id={"fn" + index}
                                  name={"fn" + index}
                                  style={{
                                    height: "2vh",
                                    marginTop: "0",
                                  }}
                                  type="text"
                                  value={inputs[index]}
                                  onChange={(e) =>
                                    setInputs((prev) => {
                                      return {
                                        ...prev,
                                        [index]: e.target.value,
                                      };
                                    })
                                  }
                                />
                                <button
                                  className="refreshButton"
                                  value={index}
                                  onClick={changeFileName}
                                >
                                  zmień
                                </button>
                              </div>
                            </td>
                            <td
                              style={{
                                textAlign: "left",
                                width: "40%",
                                padding: "5px 20px",
                                height: "3vh",
                                wordWrap: "anywhere",
                              }}
                            >
                              {el.name}
                            </td>
                            <td
                              style={{
                                textAlign: "left",
                                width: "10%",
                                padding: "5px 20px",
                                height: "3vh",
                              }}
                            >
                              <button
                                className="refreshButton"
                                value={index}
                                onClick={deleteTempFile}
                              >
                                usuń
                              </button>
                            </td>
                          </tr>
                        </>
                      ))
                    : ""}
                </table>
              </div>
            </>
          ) : (
            ""
          )}
        </>
      </>
    </>
  );

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          {showEditClientAdditionalData ? (
            <EditClientAdditionalData
              close={closeEditAdditionalData}
              logClientAction={props.logClientAction}
              client={{ petitioner: generateName() }}
              tabIndex={""}
              additionalData={additionalData}
              setAdditionalData={setAdditionalData}
              mode={"add"}
            />
          ) : (
            ""
          )}

          <div id="addPaymentIC" className="inputContainer">
            {props.checkEditOption("all") ||
            props.checkEditOption("name") ||
            props.checkEditOption("phone") ||
            props.checkEditOption("mail") ||
            props.checkEditOption("lawyer") ? (
              <>
                <div className="sepAddC">Informacje o kliencie</div>
              </>
            ) : (
              ""
            )}

            {props.checkEditOption("name") ? (
              <>
                <div className="inputBox">
                  <div className="inputCol_2">
                    <label>
                      Imię i nazwisko klienta{" "}
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={name}
                      onChange={handleNameChange}
                    />
                  </div>
                  <div id="col2AddUser" className="inputCol_2">
                    <button
                      id="addButton"
                      className="acceptButton"
                      value={name}
                      onClick={handleAddClient}
                    >
                      DODAJ
                    </button>
                  </div>
                </div>

                {clientsE.length > 0 ? (
                  <div className="colClient">
                    {clientsE.map((el) => (
                      <>
                        <div className="rowClient">
                          <div className="rowClient_col1">
                            {props.mode === "edit" || props.mode === "lead"
                              ? el
                              : el.name}
                          </div>
                          <div className="rowClient_col2">
                            <button
                              id="addButton"
                              className="acceptButton"
                              value={
                                props.mode === "edit" || props.mode === "lead"
                                  ? el
                                  : el.id
                              }
                              onClick={handleDeleteClient}
                            >
                              USUŃ
                            </button>
                          </div>
                        </div>
                      </>
                    ))}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="acceptButton"
                        style={{
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                        onClick={(e) => {
                          setShowEditClientAdditionalData(true);
                        }}
                      >
                        Wprowadź adres i pesel
                      </button>
                      <span
                        style={{
                          marginLeft: "20px",
                          fontSize: "0.7vw",
                        }}
                        className="requiredStar"
                      >
                        * wymagane jest wprowadzenie peselu każdego z klientów
                      </span>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}

            {props.checkEditOption("phone") ? (
              <>
                <div className="inputBox">
                  <div className="inputCol_2">
                    <label>
                      Numer telefonu <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={phone}
                      onChange={handlePhoneChange}
                    />
                  </div>
                  <div id="col2AddUser" className="inputCol_2">
                    <button
                      id="addButton"
                      className="acceptButton"
                      value={phone}
                      onClick={handleAddPhone}
                    >
                      DODAJ
                    </button>
                  </div>
                </div>
                {phoneE.length > 0 ? (
                  <div className="colClient">
                    {phoneE.map((el) => (
                      <>
                        <div className="rowClient">
                          <div className="rowClient_col1">
                            {props.mode === "edit" || props.mode === "lead"
                              ? el
                              : el.phone}
                          </div>
                          <div className="rowClient_col2">
                            <button
                              id="addButton"
                              className="acceptButton"
                              value={
                                props.mode === "edit" || props.mode === "lead"
                                  ? el
                                  : el.id
                              }
                              onClick={handleDeletePhone}
                            >
                              USUŃ
                            </button>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}

            {props.checkEditOption("mail") ? (
              <>
                <div className="inputBox">
                  <div className="inputCol_2">
                    <label>
                      Adres e-mail <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={mail}
                      onChange={handleMailChange}
                    />
                  </div>
                  <div id="col2AddUser" className="inputCol_2">
                    <button
                      id="addButton"
                      className="acceptButton"
                      value={mail}
                      onClick={handleAddMail}
                    >
                      DODAJ
                    </button>
                  </div>
                </div>
                {mailE.length > 0 ? (
                  <div className="colClient">
                    {mailE.map((el) => (
                      <>
                        <div className="rowClient">
                          <div className="rowClient_col1">
                            {props.mode === "edit" || props.mode === "lead"
                              ? el
                              : el.mail}
                          </div>
                          <div className="rowClient_col2">
                            <button
                              id="addButton"
                              className="acceptButton"
                              value={
                                props.mode === "edit" || props.mode === "lead"
                                  ? el
                                  : el.id
                              }
                              onClick={handleDeleteMail}
                            >
                              USUŃ
                            </button>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}

            {props.mode === "edit" ? (
              <>
                {props.checkEditOption("lawyer") ? (
                  <>
                    <div className="inputBox">
                      <div className="inputCol_2">
                        <label>
                          Prawnik <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          value={{ label: lawyer, value: lawyer }}
                          options={lawyerOptions}
                          onChange={handleLawyerChange}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}

                {props.checkEditOption("all") ||
                props.checkEditOption("court") ||
                props.checkEditOption("type") ||
                props.checkEditOption("aggr_ori") ||
                props.checkEditOption("sec_wn") ||
                props.checkEditOption("status") ||
                props.checkEditOption("payed") ? (
                  <>
                    <div className="sepAddC">Informacje o sprawie</div>
                  </>
                ) : (
                  ""
                )}

                <div className="inputBox">
                  {props.checkEditOption("court") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Sąd <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={courtOptions}
                          onChange={handleCourtChange}
                          value={{ label: court, value: court }}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {props.checkEditOption("type") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Rodzaj <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={typeOptions}
                          onChange={handleTypeChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {props.checkEditOption("aggr_ori") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Oryginał umowy i pełnomocnictwa{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={oriOptions}
                          onChange={handleOrigAggrChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inputBox">
                  {props.checkEditOption("sec_wn") &&
                  type !== "antywindykacja" ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Wniosek o zabezpieczenie{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={wnOptions}
                          onChange={handleWnChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {props.checkEditOption("status") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Status sprawy <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={statusOptions}
                          onChange={handleStatusChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div className="inputBox">
                  {props.checkEditOption("status") &&
                  status === "mamy wezwanie - braki dokumentowe klienta" ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Notatka do statusu{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <textarea
                          spellCheck="false"
                          className="textAreaNote"
                          type="text"
                          id="url"
                          name="url"
                          value={statusNote}
                          onChange={handleStatusNoteChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {props.checkEditOption("payed") && type !== "antywindykacja" ? (
                  <div
                    className="multiContainer"
                    style={{ paddingTop: "2vh", width: "100%" }}
                  >
                    <div
                      style={{
                        height: "2.5vh",
                        fontWeight: "300",
                        fontSize: "1vw",
                        textTransform: "uppercase",
                        width: "100%",
                      }}
                      className="checkBox"
                    >
                      <input
                        style={{ height: "2vh", width: "auto" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={payed}
                        onChange={(e) => {
                          setPayed(e.target.checked);
                        }}
                      />
                      Kredyt spłacony
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {props.checkEditOption("markAggr") ? (
                  <div
                    className="multiContainer"
                    style={{ paddingTop: "2vh", width: "100%" }}
                  >
                    <div
                      style={{
                        height: "2.5vh",
                        fontWeight: "300",
                        fontSize: "1vw",
                        textTransform: "uppercase",
                        width: "100%",
                      }}
                      className="checkBox"
                    >
                      <input
                        style={{ height: "2vh", width: "auto" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={markAggr}
                        onChange={(e) => {
                          setMarkAggr(e.target.checked);
                        }}
                      />
                      Zgoda marketingowa
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {props.checkEditOption("all") ||
                props.checkEditOption("bank") ||
                props.checkEditOption("credit_value") ? (
                  <>
                    <div className="sepAddC">Informacje o kredycie</div>
                  </>
                ) : (
                  ""
                )}

                <div className="inputBox">
                  {props.checkEditOption("bank") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Bank <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          value={{ label: bank, value: bank }}
                          options={bankOptions}
                          onChange={handleBankChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {props.checkEditOption("credit_value") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Kwota kredytu <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={creditValue}
                          onChange={handleCreditValueChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {props.checkEditOption("credit_value") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Waluta kredytu <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          value={{
                            label: creditCurrency,
                            value: creditCurrency,
                          }}
                          options={currencyOptions}
                          onChange={handleCreditCurrencyChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                {props.checkEditOption("credit_date") ? (
                  <>
                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Data umowy kredytowej{" "}
                          {type !== "antywindykacja" ? (
                            <span className="requiredStar">*</span>
                          ) : (
                            ""
                          )}
                        </label>
                        <input
                          type="date"
                          id="name"
                          name="name"
                          value={creaditDate_real}
                          onChange={handleCreditDateRealChange}
                        />
                      </div>

                      <div className="inputCol_3">
                        <label>
                          Numer umowy kredytowej
                          {type !== "antywindykacja" ? (
                            <span className="requiredStar">*</span>
                          ) : (
                            ""
                          )}
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={credit_aggr_num}
                          onChange={handleCreditAggrNumChange}
                        />
                      </div>

                      <div className="inputCol_3"></div>
                    </div>
                  </>
                ) : (
                  ""
                )}

                {props.checkEditOption("all") ||
                props.checkEditOption("aggr_cond") ||
                props.checkEditOption("sign_aggr") ||
                props.checkEditOption("note") ? (
                  <>
                    <div className="sepAddC">Warunki współpracy</div>
                  </>
                ) : (
                  ""
                )}

                <div className="inputBox">
                  {props.checkEditOption("aggr_cond") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Opłata wstępna <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={ow}
                          onChange={handleOwChange}
                        />
                      </div>

                      <div className="inputCol_3">
                        <label>
                          Success fee <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={sf}
                          onChange={handleSfChange}
                          onKeyPress={(e) =>
                            !/^\d*\,?\d*$/.test(e.key) && e.preventDefault()
                          }
                        />
                      </div>

                      <div className="inputCol_3">
                        <label>
                          Success fee liczone od:
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={sftypeOptions}
                          onChange={handleSfTypeChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {props.checkEditOption("sign_aggr") ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Data umowy z kancelarią{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="date"
                          id="name"
                          name="name"
                          value={creditDate}
                          onChange={handleCreditDateChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                {props.checkEditOption("note") ? (
                  <>
                    <div className="inputBox">
                      <div className="inputCol_1">
                        <label>
                          Notatka <span className="requiredStar">*</span>
                        </label>
                        <textarea
                          spellCheck="false"
                          className="textAreaNote"
                          type="text"
                          id="url"
                          name="url"
                          value={note}
                          onChange={handleNoteChange}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
            {props.mode === "add" || props.mode === "lead" ? (
              <>
                {props.team === 0 ? (
                  <>
                    <div className="inputBox">
                      <div className="inputCol_2">
                        <label>
                          Zespół <span className="requiredStar">*</span>
                        </label>
                        <select
                          type="text"
                          id="court"
                          name="court"
                          value={nTeam}
                          onChange={(e) => setNTeam(e.target.value)}
                        >
                          <option key={0} value="1">
                            1
                          </option>
                          <option key={1} value="2">
                            2
                          </option>
                        </select>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="inputBox">
                  <div className="inputCol_2">
                    <label>
                      Prawnik <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      value={{ label: lawyer, value: lawyer }}
                      options={lawyerOptions}
                      onChange={handleLawyerChange}
                    />
                  </div>
                </div>

                <div className="sepAddC">Informacje o sprawie</div>
                <div className="inputBox">
                  <div className="inputCol_3">
                    <label>
                      Sąd <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      options={courtOptions}
                      onChange={handleCourtChange}
                      value={{ label: court, value: court }}
                    />
                  </div>

                  <div className="inputCol_3">
                    <label>
                      Rodzaj <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      options={typeOptions}
                      onChange={handleTypeChange}
                    />
                  </div>

                  <div className="inputCol_3">
                    <label>
                      Oryginał umowy i pełnomocnictwa{" "}
                      <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      options={oriOptions}
                      onChange={handleOrigAggrChange}
                    />
                  </div>
                </div>
                <div className="inputBox">
                  {type !== "antywindykacja" ? (
                    <div className="inputCol_3">
                      <label>
                        Wniosek o zabezpieczenie{" "}
                        <span className="requiredStar">*</span>
                      </label>
                      <Select
                        noOptionsMessage={() => "Brak danych"}
                        placeholder={"Wybierz..."}
                        isClearable={false}
                        options={wnOptions}
                        onChange={handleWnChange}
                        value={{ label: wn, value: wn }}
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="inputCol_3">
                    <label>
                      Status sprawy <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      options={statusOptions}
                      onChange={handleStatusChange}
                    />
                  </div>
                  {type === "antywindykacja" ? (
                    <div className="inputCol_3">
                      <label>
                        Zespół <span className="requiredStar">*</span>
                      </label>
                      <Select
                        noOptionsMessage={() => "Brak danych"}
                        placeholder={"Wybierz..."}
                        isClearable={false}
                        options={[
                          { label: "1", value: "1" },
                          { label: "2", value: "2" },
                        ]}
                        value={{ label: teamA, value: teamA }}
                        onChange={(e) => {
                          setTeamA(e.value);
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="inputBox">
                  {status === "mamy wezwanie - braki dokumentowe klienta" ? (
                    <>
                      <div className="inputCol_3">
                        <label>
                          Notatka do statusu{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <textarea
                          spellCheck="false"
                          className="textAreaNote"
                          type="text"
                          id="url"
                          name="url"
                          value={statusNote}
                          onChange={handleStatusNoteChange}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {type !== "antywindykacja" ? (
                  <div
                    className="multiContainer"
                    style={{ paddingTop: "2vh", width: "100%" }}
                  >
                    <div
                      style={{
                        height: "2.5vh",
                        fontWeight: "300",
                        fontSize: "1vw",
                        textTransform: "uppercase",
                        width: "100%",
                      }}
                      className="checkBox"
                    >
                      <input
                        style={{ height: "2vh", width: "auto" }}
                        id="checkCal2"
                        type="checkbox"
                        checked={payed}
                        onChange={(e) => {
                          setPayed(e.target.checked);
                        }}
                      />
                      Kredyt spłacony
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div
                  className="multiContainer"
                  style={{ paddingTop: "2vh", width: "100%" }}
                >
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "1vw",
                      textTransform: "uppercase",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ height: "2vh", width: "auto" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={markAggr}
                      onChange={(e) => {
                        setMarkAggr(e.target.checked);
                      }}
                    />
                    Zgoda marketingowa
                  </div>
                </div>

                {type === "antywindykacja" ? (
                  <>
                    <div className="sepAddC">antywindykacja</div>
                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Kwota roszczenia{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={ammountA}
                          onChange={(e) => {
                            setAmmountA(e.target.value);
                          }}
                        />
                      </div>

                      <div className="inputCol_3">
                        <label>
                          Rodzaj tytułu egzekucyjnego{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={titleAOptions}
                          value={{ label: titleA, value: titleA }}
                          onChange={(e) => {
                            setTitleA(e.value);
                          }}
                        />
                      </div>

                      <div className="inputCol_3">
                        <label>
                          Czy w sprawie jest komornik?
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={[
                            { label: "TAK", value: "TAK" },
                            { label: "NIE", value: "NIE" },
                          ]}
                          value={{ label: komorA, value: komorA }}
                          onChange={(e) => {
                            setKomorA(e.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Data odebrania nakazu/wezwania
                          <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="date"
                          id="name"
                          name="name"
                          value={nakDateA}
                          onChange={(e) => {
                            setNakDateA(e.target.value);
                          }}
                        />
                      </div>
                      <div className="inputCol_3">
                        <label>
                          Rodzaj postepowania
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={[
                            { label: "EPU", value: "EPU" },
                            { label: "ZWYKŁA", value: "ZWYKŁA" },
                          ]}
                          value={{ label: rodzPostA, value: rodzPostA }}
                          onChange={(e) => {
                            setRodzPostA(e.value);
                          }}
                        />
                      </div>
                      <div className="inputCol_3">
                        <label>
                          Kontynuacja EPU?
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={[
                            { label: "TAK", value: "TAK" },
                            { label: "NIE", value: "NIE" },
                          ]}
                          value={{ label: conEpuA, value: conEpuA }}
                          onChange={(e) => {
                            setConEpuA(e.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="inputBox">
                      {rodzPostA === "EPU" ? (
                        <div className="inputCol_3">
                          <label>
                            Dane logowania do EPU
                            <span className="requiredStar">*</span>
                          </label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            value={logEpuA}
                            onChange={(e) => {
                              setLogEpuA(e.target.value);
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="inputCol_3">
                        <label>
                          Wpłaty na poczet wykonywania umowy
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={[
                            { label: "TAK", value: "TAK" },
                            { label: "NIE", value: "NIE" },
                          ]}
                          value={{ label: wnpwuA, value: wnpwuA }}
                          onChange={(e) => {
                            setWnpwuA(e.value);
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}

                <div className="sepAddC">Informacje o kredycie</div>

                <div className="inputBox">
                  <div className="inputCol_3">
                    <label>
                      Bank <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      value={{ label: bank, value: bank }}
                      options={bankOptions}
                      onChange={handleBankChange}
                    />
                  </div>

                  <div className="inputCol_3">
                    <label>
                      Kwota kredytu{" "}
                      {type !== "antywindykacja" ? (
                        <span className="requiredStar">*</span>
                      ) : (
                        ""
                      )}
                    </label>
                    <input
                      type="number"
                      id="name"
                      name="name"
                      value={creditValue}
                      onChange={handleCreditValueChange}
                    />
                  </div>

                  <div className="inputCol_3">
                    <label>
                      Waluta kredytu <span className="requiredStar">*</span>
                    </label>
                    <Select
                      noOptionsMessage={() => "Brak danych"}
                      placeholder={"Wybierz..."}
                      isClearable={false}
                      value={{ label: creditCurrency, value: creditCurrency }}
                      options={currencyOptions}
                      onChange={handleCreditCurrencyChange}
                    />
                  </div>
                </div>

                <div className="inputBox">
                  <div className="inputCol_3">
                    <label>
                      Data umowy kredytowej{" "}
                      {type !== "antywindykacja" ? (
                        <span className="requiredStar">*</span>
                      ) : (
                        ""
                      )}
                    </label>
                    <input
                      type="date"
                      id="name"
                      name="name"
                      value={creaditDate_real}
                      onChange={handleCreditDateRealChange}
                    />
                  </div>

                  <div className="inputCol_3">
                    <label>
                      Numer umowy kredytowej
                      {type !== "antywindykacja" ? (
                        <span className="requiredStar">*</span>
                      ) : (
                        ""
                      )}
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={credit_aggr_num}
                      onChange={handleCreditAggrNumChange}
                    />
                  </div>

                  <div className="inputCol_3"></div>
                </div>

                {+props.team === 2 ? (
                  <>
                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Źródło <span className="requiredStar">*</span>
                        </label>
                        <select
                          type="text"
                          id="court"
                          name="court"
                          value={source}
                          onChange={handleSourceChange}
                        >
                          <option key={0} value="własna">
                            WŁASNA
                          </option>
                          <option key={2} value="LEX CHF">
                            LEX CHF
                          </option>
                          <option key={3} value="FREJOWSKI CHF">
                            FREJOWSKI CHF
                          </option>
                        </select>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}

                {source === "LEX CHF" || source === "FREJOWSKI CHF" ? (
                  ""
                ) : (
                  <>
                    <div className="sepAddC">Warunki współpracy</div>

                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Opłata wstępna <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={ow}
                          onChange={handleOwChange}
                        />
                      </div>

                      <div className="inputCol_3">
                        <label>
                          Success fee <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={sf}
                          onChange={handleSfChange}
                          onKeyPress={(e) =>
                            !/^\d*\,?\d*$/.test(e.key) && e.preventDefault()
                          }
                        />
                      </div>

                      <div className="inputCol_3">
                        <label>
                          Success fee liczone od:
                          <span className="requiredStar">*</span>
                        </label>
                        <Select
                          noOptionsMessage={() => "Brak danych"}
                          placeholder={"Wybierz..."}
                          isClearable={false}
                          options={sftypeOptions}
                          onChange={handleSfTypeChange}
                        />
                      </div>
                    </div>
                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Data umowy z kancelarią{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="date"
                          id="name"
                          name="name"
                          value={creditDate}
                          onChange={handleCreditDateChange}
                        />
                      </div>
                    </div>

                    <div className="sepAddC">
                      Płatności - pierwszy identyfikator
                    </div>

                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>Numer konta bankowego</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={bankAcc}
                          onChange={handleBankAccChange}
                        />
                      </div>
                      <div className="inputCol_3">
                        <label>
                          Marka <span className="requiredStar">*</span>
                        </label>
                        <select
                          type="text"
                          id="court"
                          name="court"
                          value={brand}
                          onChange={handleBrandChange}
                        >
                          <option key={0} value="KPPP">
                            KPPP
                          </option>
                          <option key={1} value="Wygrywamy z bankami">
                            Wygrywamy z bankami
                          </option>
                          <option key={2} value="Anulujemy Kredyt CHF">
                            Anulujemy Kredyt CHF
                          </option>
                          <option key={3} value="Frankowa Kancelaria">
                            Frankowa Kancelaria
                          </option>
                        </select>
                      </div>
                      <div className="inputCol_3">
                        <label>
                          Data pierwszej płatności{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="date"
                          id="name"
                          name="name"
                          value={firstPayDate}
                          onChange={handleFirstPayDateChange}
                        />
                      </div>
                    </div>
                    <div className="inputBox">
                      <div className="inputCol_3">
                        <label>
                          Rodzaj <span className="requiredStar">*</span>
                        </label>
                        <select
                          type="text"
                          id="court"
                          name="court"
                          value={typeP}
                          onChange={handleTypePChange}
                        >
                          <option key={0} value="Opłata wstępna">
                            Opłata wstępna
                          </option>
                          <option key={1} value="Success Fee">
                            Success Fee
                          </option>
                          <option key={2} value="Opłata za rozprawę">
                            Opłata za rozprawę
                          </option>
                          <option key={3} value="KZP I Instancja">
                            KZP I Instancja
                          </option>
                          <option key={4} value="KZP II Instancja">
                            KZP II Instancja
                          </option>
                          <option key={5} value="KZP SN">
                            KZP SN
                          </option>
                          <option
                            key={6}
                            value="Wynagrodzenie za skargę kasacyjną"
                          >
                            Wynagrodzenie za skargę kasacyjną
                          </option>
                          <option key={7} value="KZP I i II instancja łącznie">
                            KZP I i II instancja łącznie
                          </option>
                        </select>
                      </div>
                      <div className="inputCol_3">
                        <label>
                          Kwota rozliczenia{" "}
                          <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={ow}
                          onChange={handleOwChange}
                        />
                      </div>
                      <div className="inputCol_3">
                        <label>
                          Ilość rat <span className="requiredStar">*</span>
                        </label>
                        <input
                          type="number"
                          id="name"
                          name="name"
                          value={installmentCount}
                          onChange={handleInstallmentCountChange}
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="inputBox">
                  <div className="inputCol_1">
                    <label>
                      Notatka <span className="requiredStar">*</span>
                    </label>
                    <textarea
                      spellCheck="false"
                      className="textAreaNote"
                      type="text"
                      id="url"
                      name="url"
                      value={note}
                      onChange={handleNoteChange}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            <div style={{ marginTop: "5vh" }}>
              {props.mode === "lead" ? <>{documentsView}</> : ""}
            </div>

            <div className="inputBox" style={{ display: "block" }}>
              {addFile}
            </div>

            <div className="saveBoxAP">
              <button
                className="paymentMenuButton"
                onClick={props.mode === "edit" ? editClient : addPayment}
              >
                zapisz
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddClient;
